import React from "react";

import { Switch, Route } from "react-router-dom";
import InfoProfile from "./_info/InfoProfile";
import FinanceProfile from "./_finance/FinanceProfile";
import ResultProfile from "./_results/ResultProfile";
import AttendanceProfile from "./_attendance/AttendanceProfile";

const Routes = () => {
  const basePath = "/mis";

  return (
    <Switch>
      <Route
        path={`${basePath}/students/:sid/profile/info`}
        render={(p) => <InfoProfile {...p} />}
      />
      <Route
        path={`${basePath}/students/:sid/profile/fees`}
        render={(p) => <FinanceProfile {...p} />}
      />
      <Route
        path={`${basePath}/students/:sid/profile/attendance`}
        render={(p) => <AttendanceProfile {...p} />}
      />
      <Route
        path={`${basePath}/students/:sid/profile/results`}
        render={(p) => <ResultProfile {...p} />}
      />
    </Switch>
  );
};

export default Routes;
